export const topics = [
  'Гражданское воспитание',
  'Патриотическое воспитание и формирование российской идентичности',
  'Духовное и нравственное воспитание',
  'Приобщение к культурному наследию',
  'Популяризация научных знаний',
  'Физическое воспитание и формирование культуры здоровья',
  'Трудовое воспитание и профессиональное самоопределение',
  'Экологическое воспитание',
]